<template>
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="8.14618" cy="8.20151" rx="7.04853" ry="6.9144" stroke="currentColor" stroke-width="1.33187"/>
        <path d="M12.3633 13.8809L16.9018 18.7128" stroke="currentColor" stroke-width="1.33187" stroke-linecap="round"/>
    </svg>
</template>
